import { get, post, patch } from 'helpers/api';

const rootPath = '/contacts/task_tags';

export const fetchTag = id => (
  get(`${rootPath}/${id}.json`).then(response => response.taskTag)
);

export const searchTags = (searchTerm, onSuccess) => (
  get(`${rootPath}.json`, { params: { 'q[name_cont]': searchTerm } })
    .then(function (response) {
      onSuccess(response.taskTags || []);
    })
);

export const createTag = params => (
  post(`${rootPath}.json`, params)
);

export const updateTag = (tag, params) => (
  patch(`${rootPath}/${tag.id}.json`, params)
);
